export const GRAPHQL_VARIABLES = {
  filter: {
    _id: '5fd6a6ddf0d2e8b9dbf73678'
  }
};

export const QUERY = `
mutation companiesRemove ($filter: AutoFilledFilterRemoveOnecompaniesInput!, $sort: SortRemoveOnecompaniesInput) {
  companiesRemove (filter: $filter, sort: $sort) {
      recordId
      record {
          name
          address {
              address1
              address2
              address3
              state
              city
              zip
              country
              _id
          }
          email
          bookipiCompany
          phoneNumber
          website
          businessType
          businessName
          description
          ABN
          industry
          bankDetails {
              bankName
              accountName
              accountNo
              routingNumber
          }
          individuals {
              title
              birth
              firstName
              ownership
              address {
                  address1
                  address2
                  address3
                  state
                  city
                  zip
                  country
                  _id
              }
              email
              phone
              _id
          }
          monthlyCardValue
          monthlyTransactions
          annualTurnover
          serviceDeliveryDays
          hasSignature
          verified
          currency
          _id
          updatedAt
          createdAt
      }
      error {
          message
      }
  }
}
`;
